// removed by extract-text-webpack-plugin
module.exports = {"page":"_3IB87","heading":"_2EsDX"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Hierarchy.css
// module id = 854
// module chunks = 0